import React, { useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import useCurrentBusinessInfo from "../../hooks/useCurrentBusiness";
import { useGetDescription } from "../../services/api/business/businessDescription.api";

// ——— Netflix-ish tokens (design only)
const COLORS = {
  bg: "#0b0b0b",
  panel: "#141414",
  text: "#ffffff",
  muted: "rgba(255,255,255,0.78)",
  border: "rgba(255,255,255,0.12)",
  red: "#E50914",
};

export const CardShell: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Box
      sx={{
        borderRadius: "20px",
        p: { xs: 2.5, md: 3 },
        backgroundColor: COLORS.panel,
        color: COLORS.text,
        border: `1px solid ${COLORS.border}`,
        boxShadow: "0 16px 40px rgba(0,0,0,0.45)",
        position: "relative",
      }}
    >
      {children}
    </Box>
  );
};

const BusinessDescription: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [editorData, setEditorData] = useState("");

  const { currentBusiness } = useCurrentBusinessInfo();

  const { data, refetch, isLoading } = useGetDescription({
    key: ["getDescription", currentBusiness?.id],
    params: { businessId: currentBusiness?.id || 0 },
  });

  const description = data?.data[0]?.html ?? "";

  return (
    <CardShell>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 120,
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          {data?.data?.length === 0 && (
            <Typography
              sx={{
                mt: 3,
                color: COLORS.muted,
              }}
            >
              No description found
            </Typography>
          )}
          <Typography
            component="div"
            sx={{
              font: "var(--body-md)",
              color: COLORS.text,
              "& *": {
                color: COLORS.text,
              },
            }}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </>
      )}
    </CardShell>
  );
};

export default BusinessDescription;
